import * as React from 'react'
import { View, ViewStyle } from 'react-native'

interface ColumnProps extends Omit<ViewStyle, 'flexDirection'> {}

export const Column: React.FC<ColumnProps> = ({ children, ...style }) => {
  return <View style={[{ flexDirection: 'column' }, style]}>{children}</View>
}
